module.exports = __webpack_public_path__ + "img/1.443886f4.jpg";